import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`;

export const CarouselWrapper = styled.div`
  margin: 0 auto;
  position: absolute;
  top: -150px;
  left: -190px;
  width: 100vw !important;
  z-index: -1;

  div {
    height: 783px;
    width: 100%;
  }

  ${media.lessThan("medium")`
    left: -180px;
  `}

  ${media.lessThan("small")`
    left: -20px;
  `}
`;

export const BannerImg = styled.img`
  height: 100%;
  object-fit: cover;
  opacity: 0.6;
  width: 100vw;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  width: 100%;

  position: relative;
`;

export const Description = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutral.white};
  max-width: 600px;
  line-height: 24px;

  padding-top: 50px;
`;

export const Logo = styled.img`
  width: 480px;
  height: 80px;

  object-fit: contain;

  ${media.lessThan("medium")`
    width: 60%;
  `}
`;

export const Felipe = styled.img`
  height: 300px;

  object-fit: contain;

  ${media.lessThan("medium")`
    width: 60%;
  `}
`;

export const Main = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;

  ${media.lessThan("medium")`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 40px;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  h2 {
    font-size: 32px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
    max-width: 600px;
    line-height: 24px;
  }
`;
